import * as indicatorTypes from "@chartLib/lib/indicator";
import * as seriesTypes from "@chartLib/lib/series";
import * as tooltipTypes from "@chartLib/lib/tooltip";
import * as coordinateTypes from "@chartLib/lib/coordinates";
import {
  WindowSizeType,
  SourcePathType,
  StrokeType,
  OffsetBarsType,
} from "../PropertyTypes";

const movingAveragesRegistry = {
  displayName: "Médias Móveis",
  tooltip: tooltipTypes.MovingAverageTooltip,
  indicators: {
    sma: {
      displayName: "Média Móvel Simples (SMA)",
      key: "sma",
      type: indicatorTypes.sma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      defaultOptions: [
        WindowSizeType({ defaultValue: 10 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    ema: {
      displayName: "Média Móvel Exponencial (EMA)",
      key: "ema",
      type: indicatorTypes.ema,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      defaultOptions: [
        WindowSizeType({ defaultValue: 10 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    wma: {
      displayName: "Média Móvel Ponderada (WMA)",
      key: "wma",
      type: indicatorTypes.wma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      defaultOptions: [
        WindowSizeType({ defaultValue: 10 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#4CAF50",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    hma: {
      displayName: "Média Móvel de Hull (HMA)",
      key: "hma",
      type: indicatorTypes.hma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      defaultOptions: [
        WindowSizeType({ defaultValue: 9 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF5722",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    tma: {
      displayName: "Média Móvel Triangular (TMA)",
      key: "tma",
      type: indicatorTypes.tma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      defaultOptions: [
        WindowSizeType({ defaultValue: 10 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#9C27B0",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    dema: {
      displayName: "Média Móvel Dupla Exponencial (DEMA)",
      key: "dema",
      type: indicatorTypes.dema,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      defaultOptions: [
        WindowSizeType({ defaultValue: 10 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#E91E63",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    tema: {
      displayName: "Média Móvel Exponencial Tripla (TEMA)",
      key: "tema",
      type: indicatorTypes.tema,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({ defaultValue: 12 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        // Destrava o DESLOCAR que o calculator do TEMA já portava do engine e
        // que nunca chegou à UI (dívida da migração).
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          // Cor default = cor do engine Silverlight (série sem SetAttrs → amarelo
          // do engine, colhido no OOB vivo). Ver LICOES.md (regra permanente).
          defaultValue: {
            color: "#FFFF00",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    vidya: {
      displayName: "VIDYA (Variable Index Dynamic Average)",
      key: "vidya",
      type: indicatorTypes.vidya,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({ defaultValue: 14 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#00BCD4",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    tsma: {
      displayName: "Média Móvel de Série Temporal (TSMA)",
      key: "tsma",
      type: indicatorTypes.tsma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({ defaultValue: 10 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#9C27B0",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    vma: {
      displayName: "Média Móvel Variável (VMA)",
      key: "vma",
      type: indicatorTypes.vma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({ defaultValue: 9 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#009688",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    smma: {
      displayName: "Média Móvel Suavizada (SMMA / Welles Wilder)",
      key: "smma",
      type: indicatorTypes.smma,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: false,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({ defaultValue: 14 }),
        SourcePathType({ defaultValue: "close", allowSeriesSource: true }),
        // FML.WMA do Silverlight é WilderMA — falso-amigo: mapeia para o smma
        // do odin, não para o wma (ponderada).
        OffsetBarsType(),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#795548",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    medianPrice: {
      displayName: "Preço Mediano (Median Price)",
      key: "medianPrice",
      type: indicatorTypes.medianPrice,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: true,
      defaultOptions: [
        WindowSizeType({
          defaultValue: 14,
          displayName: "Período",
          min: 1,
          max: 100,
        }),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
      tooltip: tooltipTypes.SingleValueTooltip,
      tooltipProps: {
        yLabel: "Median",
      },
      renderKey: "medianPrice",
      yAxisId: "MedianPrice",
      separatePanel: true,
      description:
        "Média móvel simples do ponto médio entre máxima e mínima: SMA((High + Low) / 2, Period)",
    },
    typicalPrice: {
      displayName: "Preço Típico (Typical Price)",
      key: "typicalPrice",
      type: indicatorTypes.typicalPrice,
      series: seriesTypes.LineSeries,
      coordinate: coordinateTypes.CurrentCoordinate,
      requireNewAxis: true,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({
          name: "windowSize",
          displayName: "Período",
          defaultValue: 14,
        }),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#00BCD4",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
      tooltip: tooltipTypes.TypicalPriceTooltip,
      renderKey: "typicalPrice",
      yAxisId: "TypicalPrice",
      decimalPlaces: 2,
      separatePanel: true,
      description:
        "Média móvel simples do Typical Price: SMA((High + Low + Close) / 3, Period)",
    },
    rainbowMA: {
      displayName: "Rainbow MA (Média Móvel Arco-Íris)",
      key: "rainbowMA",
      type: indicatorTypes.rainbowMA,
      series: seriesTypes.RainbowMASeries,
      requireNewAxis: false,
      isPriceAxis: true,
      defaultOptions: [
        WindowSizeType({
          name: "period",
          defaultValue: 2,
          displayName: "Período",
          min: 2,
          max: 10,
        }),
        SourcePathType({ defaultValue: "close" }),
      ],
      defaultOptionsForAppearance: [
        StrokeType({
          name: "strokeSMA1",
          displayName: "SMA 1 (Vermelho)",
          defaultValue: {
            color: "#FF0000",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA2",
          displayName: "SMA 2 (Laranja)",
          defaultValue: {
            color: "#FF7F00",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA3",
          displayName: "SMA 3 (Amarelo)",
          defaultValue: {
            color: "#FFFF00",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA4",
          displayName: "SMA 4 (Verde-Amarelo)",
          defaultValue: {
            color: "#7FFF00",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA5",
          displayName: "SMA 5 (Verde-Ciano)",
          defaultValue: {
            color: "#00FF7F",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA6",
          displayName: "SMA 6 (Ciano)",
          defaultValue: {
            color: "#00FFFF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA7",
          displayName: "SMA 7 (Ciano-Azul)",
          defaultValue: {
            color: "#007FFF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA8",
          displayName: "SMA 8 (Azul)",
          defaultValue: {
            color: "#0000FF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA9",
          displayName: "SMA 9 (Roxo)",
          defaultValue: {
            color: "#7F00FF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        StrokeType({
          name: "strokeSMA10",
          displayName: "SMA 10 (Magenta)",
          defaultValue: {
            color: "#FF00FF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
      labelConfig: {
        lines: [
          { key: "sma1", colorPath: "strokeSMA1.color" },
          { key: "sma2", colorPath: "strokeSMA2.color" },
          { key: "sma3", colorPath: "strokeSMA3.color" },
          { key: "sma4", colorPath: "strokeSMA4.color" },
          { key: "sma5", colorPath: "strokeSMA5.color" },
          { key: "sma6", colorPath: "strokeSMA6.color" },
          { key: "sma7", colorPath: "strokeSMA7.color" },
          { key: "sma8", colorPath: "strokeSMA8.color" },
          { key: "sma9", colorPath: "strokeSMA9.color" },
          { key: "sma10", colorPath: "strokeSMA10.color" },
        ],
      },
      tooltip: tooltipTypes.RainbowMATooltip,
      renderKey: "rainbowMA",
      decimalPlaces: 2,
    },
  },
};

export default movingAveragesRegistry;
